module.exports = __webpack_public_path__ + "static/media/knee_evaluation_home.8cdb5bea.png";